module.exports = __webpack_public_path__ + "static/img/jskx2025.9e4549c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/banner/jskx2025.jpg
// module id = /Fqm
// module chunks = 51